import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "create-product-container max-w-4xl mx-auto py-6 px-4 sm:px-6 lg:px-8" }
const _hoisted_2 = {
  key: 0,
  class: "mb-6"
}
const _hoisted_3 = {
  key: 1,
  class: "mb-6"
}
const _hoisted_4 = {
  key: 0,
  class: "bg-red-900/30 border border-red-500 rounded-lg p-4 mb-6"
}
const _hoisted_5 = { class: "flex items-start" }
const _hoisted_6 = { class: "text-red-300 text-sm" }
const _hoisted_7 = {
  key: 1,
  class: "bg-red-900/30 border border-red-500 rounded-lg p-4 mb-6"
}
const _hoisted_8 = { class: "flex items-start" }
const _hoisted_9 = { class: "text-red-300 text-sm" }
const _hoisted_10 = {
  key: 2,
  class: "bg-yellow-900/30 border border-yellow-500 rounded-lg p-4 mb-6"
}
const _hoisted_11 = { class: "flex items-start" }
const _hoisted_12 = { class: "text-yellow-300 text-sm" }
const _hoisted_13 = { class: "bg-gray-800 shadow rounded-lg px-4 py-5 sm:p-6 overflow-hidden" }
const _hoisted_14 = {
  key: 0,
  class: "relative"
}
const _hoisted_15 = { class: "opacity-25 pointer-events-none" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductForm = _resolveComponent("ProductForm")!
  const _component_ToastNotification = _resolveComponent("ToastNotification")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
      class: "flex items-center text-gray-400 hover:text-blue-400 mb-6 transition-colors"
    }, _cache[2] || (_cache[2] = [
      _createElementVNode("span", { class: "mr-2" }, "←", -1),
      _createTextVNode(" Nazad ")
    ])),
    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "mb-6" }, [
      _createElementVNode("h1", { class: "text-2xl font-bold text-white mb-2" }, "Dodaj novi oglas"),
      _createElementVNode("p", { class: "text-gray-400" }, " Popunite sve potrebne informacije o proizvodu koji želite da prodate ")
    ], -1)),
    (_ctx.isLoadingStats)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[3] || (_cache[3] = [
          _createElementVNode("div", { class: "bg-gray-800 rounded-lg p-4 flex items-center justify-center" }, [
            _createElementVNode("div", { class: "animate-spin rounded-full h-5 w-5 border-b-2 border-blue-500 mr-3" }),
            _createElementVNode("span", { class: "text-gray-400" }, "Proverava se broj aktivnih oglasa...")
          ], -1)
        ])))
      : _createCommentVNode("", true),
    (!_ctx.isLoadingStats)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.userStats.remainingSlots === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _cache[8] || (_cache[8] = _createElementVNode("svg", {
                    class: "w-5 h-5 text-red-400 mt-0.5 mr-3 flex-shrink-0",
                    fill: "currentColor",
                    viewBox: "0 0 20 20"
                  }, [
                    _createElementVNode("path", {
                      "fill-rule": "evenodd",
                      d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                      "clip-rule": "evenodd"
                    })
                  ], -1)),
                  _createElementVNode("div", null, [
                    _cache[7] || (_cache[7] = _createElementVNode("h3", { class: "text-red-400 font-medium mb-1" }, " Dostigli ste maksimalan broj aktivnih oglasa ", -1)),
                    _createElementVNode("p", _hoisted_6, [
                      _cache[4] || (_cache[4] = _createTextVNode(" Trenutno imate ")),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.userStats.activeProductsCount), 1),
                      _cache[5] || (_cache[5] = _createTextVNode(" od ")),
                      _createElementVNode("strong", null, _toDisplayString(_ctx.userStats.maxProductsAllowed), 1),
                      _cache[6] || (_cache[6] = _createTextVNode(" dozvoljenih aktivnih oglasa. Da biste dodali novi oglas, sačekajte da neki postojeći istekne ili ga ručno obrišite. "))
                    ])
                  ])
                ])
              ]))
            : (
          _ctx.userStats.remainingSlots > 0 && _ctx.userStats.remainingSlots < 20
        )
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _cache[13] || (_cache[13] = _createElementVNode("svg", {
                      class: "w-5 h-5 text-red-400 mt-0.5 mr-3 flex-shrink-0",
                      fill: "currentColor",
                      viewBox: "0 0 20 20"
                    }, [
                      _createElementVNode("path", {
                        "fill-rule": "evenodd",
                        d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                        "clip-rule": "evenodd"
                      })
                    ], -1)),
                    _createElementVNode("div", null, [
                      _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "text-red-400 font-medium mb-1" }, " Kritično malo preostalih besplatnih oglasa ", -1)),
                      _createElementVNode("p", _hoisted_9, [
                        _cache[9] || (_cache[9] = _createTextVNode(" Možete dodati još samo ")),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.userStats.remainingSlots), 1),
                        _cache[10] || (_cache[10] = _createTextVNode(" oglasa. Trenutno imate ")),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.userStats.activeProductsCount), 1),
                        _cache[11] || (_cache[11] = _createTextVNode(" aktivnih oglasa. "))
                      ])
                    ])
                  ])
                ]))
              : (
          _ctx.userStats.remainingSlots >= 20 && _ctx.userStats.remainingSlots < 40
        )
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[18] || (_cache[18] = _createElementVNode("svg", {
                        class: "w-5 h-5 text-yellow-400 mt-0.5 mr-3 flex-shrink-0",
                        fill: "currentColor",
                        viewBox: "0 0 20 20"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z",
                          "clip-rule": "evenodd"
                        })
                      ], -1)),
                      _createElementVNode("div", null, [
                        _cache[17] || (_cache[17] = _createElementVNode("h3", { class: "text-yellow-400 font-medium mb-1" }, " Približavate se limitu maksimalnog broja besplatnih oglasa ", -1)),
                        _createElementVNode("p", _hoisted_12, [
                          _cache[14] || (_cache[14] = _createTextVNode(" Možete dodati još ")),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.userStats.remainingSlots), 1),
                          _cache[15] || (_cache[15] = _createTextVNode(" oglasa. Trenutno imate ")),
                          _createElementVNode("strong", null, _toDisplayString(_ctx.userStats.activeProductsCount), 1),
                          _cache[16] || (_cache[16] = _createTextVNode(" aktivnih oglasa. "))
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      (_ctx.userStats.remainingSlots === 0 && !_ctx.isLoadingStats)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _cache[19] || (_cache[19] = _createStaticVNode("<div class=\"absolute inset-0 bg-gray-900/75 rounded-lg z-10 flex items-center justify-center\" data-v-17dbaa9a><div class=\"text-center\" data-v-17dbaa9a><svg class=\"w-16 h-16 text-red-400 mx-auto mb-4\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" data-v-17dbaa9a><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z\" data-v-17dbaa9a></path></svg><p class=\"text-red-400 font-medium\" data-v-17dbaa9a>Forma je blokirana</p><p class=\"text-red-300 text-sm mt-1\" data-v-17dbaa9a> Dostigli ste maksimalan broj aktivnih oglasa </p></div></div>", 1)),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_ProductForm)
            ])
          ]))
        : (_openBlock(), _createBlock(_component_ProductForm, { key: 1 }))
    ]),
    _createVNode(_component_ToastNotification, {
      show: _ctx.toast.show,
      message: _ctx.toast.message,
      type: _ctx.toast.type,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toast.show = false))
    }, null, 8, ["show", "message", "type"])
  ]))
}